import { useMemo } from "react";
import { Helmet } from "react-helmet-async";
import { useAuth } from "../contexts/AuthContext";
import SiteFooter from "../Footer/SiteFooter";
import ContactForm from "../Media/ContactForm";
import Navbar from "../Navbar/Navbar";
import UserSignedIn from "../Navbar/UserSignedIn";

const ContactPage = () => {
  const { currentUser } = useAuth();

  // SEO Data
  const seoData = useMemo(
    () => ({
      title: "Contact Us | GentleGourmet - Get in Touch",
      description:
        "Have questions about digestive-friendly recipes? Want to partner with us or share feedback? Contact the GentleGourmet team. We'd love to hear from you!",
      keywords:
        "contact GentleGourmet, support, feedback, recipe questions, partnerships, get in touch",
      canonicalUrl: "https://gentlegourmet.app/pages/contact",
      ogImage: "https://gentlegourmet.app/images/og-contact.jpg",
    }),
    []
  );

  // JSON-LD Structured Data
  const jsonLdContactPage = useMemo(
    () => ({
      "@context": "https://schema.org",
      "@type": "ContactPage",
      name: "Contact GentleGourmet",
      description: seoData.description,
      url: seoData.canonicalUrl,
      mainEntity: {
        "@type": "Organization",
        name: "GentleGourmet",
        url: "https://gentlegourmet.app",
        contactPoint: {
          "@type": "ContactPoint",
          contactType: "customer support",
          availableLanguage: "English",
        },
      },
    }),
    [seoData]
  );

  const jsonLdBreadcrumbs = useMemo(
    () => ({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://gentlegourmet.app/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Contact",
          item: seoData.canonicalUrl,
        },
      ],
    }),
    [seoData]
  );

  return (
    <>
      {/* SEO Head Tags */}
      <Helmet>
        <html lang="en" />
        <title>{seoData.title}</title>
        <meta name="description" content={seoData.description} />
        <meta name="keywords" content={seoData.keywords} />
        <link rel="canonical" href={seoData.canonicalUrl} />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content={seoData.title} />
        <meta property="og:description" content={seoData.description} />
        <meta property="og:url" content={seoData.canonicalUrl} />
        <meta property="og:image" content={seoData.ogImage} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="GentleGourmet" />
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoData.title} />
        <meta name="twitter:description" content={seoData.description} />
        <meta name="twitter:image" content={seoData.ogImage} />
        <script type="application/ld+json">
          {JSON.stringify(jsonLdContactPage)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(jsonLdBreadcrumbs)}
        </script>
      </Helmet>

      <div className="ContactPageContainer">
        <ContactForm />
      </div>
    </>
  );
};

export default ContactPage;
